import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { resolveModifiers } from '../utils/resolve-modifiers'

export function GroveBlueprintDivider({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Divider') {
    return null
  }

  const { className, style, attributes } = resolveModifiers(
    node.modifiers,
    bindingValues,
    (key: string) => getRemoteString({ key }),
  )

  return (
    <hr
      className={`border-acorns-ivory border-0 border-b-[10px] w-full ${className}`.trim()}
      style={style}
      {...attributes}
    />
  )
}
